import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  Typography,
} from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import t from "./translations";
import {
  useDatasetViewerSettings,
  type ProjectNameDisplay,
} from "./hooks/useDatasetViewerSettings";

export function DatasetViewerSettingsModal() {
  const [open, setOpen] = useState(false);
  const { projectNameDisplay, setProjectNameDisplay } =
    useDatasetViewerSettings();

  return (
    <>
      <Tooltip title={t.Settings}>
        <IconButton
          onClick={() => setOpen(true)}
          color="inherit"
          data-testid="dataset-viewer-settings-button"
        >
          <SettingsIcon />
        </IconButton>
      </Tooltip>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="xs"
        fullWidth
        data-testid="dataset-viewer-settings-modal"
      >
        <DialogTitle>{t.Settings}</DialogTitle>
        <DialogContent>
          <Stack
            sx={{
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 2,
            }}
          >
            <Typography variant="body2">{t.ProjectNameDisplay}</Typography>
            <ToggleButtonGroup
              value={projectNameDisplay}
              exclusive
              onChange={(_, value) => {
                if (value !== null) {
                  setProjectNameDisplay(value as ProjectNameDisplay);
                }
              }}
              size="small"
            >
              <ToggleButton value="id" data-testid="project-name-display-id">
                {t.DisplayID}
              </ToggleButton>
              <ToggleButton value="name" data-testid="project-name-display-name">
                {t.Name}
              </ToggleButton>
              <ToggleButton
                value="id_and_name"
                data-testid="project-name-display-id-and-name"
              >
                {t.DisplayIDAndName}
              </ToggleButton>
            </ToggleButtonGroup>
          </Stack>
        </DialogContent>
      </Dialog>
    </>
  );
}
